module.exports = __webpack_public_path__ + "static/media/facebook.d8df5b5d.svg";